<template>
  <div class="auth-wrapper"></div>
</template>

<script>
  import { mapActions } from "vuex";
  import { checkForUnsafeChars } from "@/assets/utilities/helpers/sanitization";

  export default {
    name: "EmailVerify",
    async beforeMount() {
      if (checkForUnsafeChars(this.$route.params.token)) {
        const token = this.$route.params.token;
        const userLoggedIn = !!this.$store.state.user?.id;

        try {
          const { data } = await this.$admin.dataProvider.customHttpCall("POST", `users/${token}/verify`);
          if (data.result === "SUCCESS") {
            this.$admin.toast.success(data.message);
            if (userLoggedIn) {
              await this.refreshAndStoreAllUserData();
              this.$router.push({ name: "dashboard" });
            } else {
              this.$router.push({ name: "login" });
            }
          }
        } catch (err) {
          this.$admin.toast.error(err.description || this.$t("generic.error"));
          if (userLoggedIn) {
            // Navigating to homepage clears the toast. Allowing some time to pass so that error toast is visible;
            setTimeout(() => {
              this.$router.push({ name: "dashboard" });
            }, 1500);
          } else {
            this.$router.push({ name: "login" });
          }
        }
      } else {
        console.error(this.$t("generic.special_characters_not_allowed"));
      }
    },
    methods: {
      ...mapActions({
        refreshAndStoreAllUserData: "refreshAndStoreAllUserData",
      }),
    },
  };
</script>

<style lang="scss" scoped></style>
